import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './layouts/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Profile from './pages/Profile';
import SignUpForm from './pages/SignUp';
import Feature from './pages/Feature';
import ChatPage from './pages/AiChat';
import RoleProvider from './context/RoleContext';
import { AuthProvider } from './context/AuthProvider';  // Import AuthProvider

function App() {
  return (
    <AuthProvider> {/* Wrap the app with AuthProvider */}
      <RoleProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUpForm />} />
            <Route path="/feature" 
              element={
                <ProtectedRoute>
                  <Feature />
                </ProtectedRoute>} />
            <Route path="/mysidekick" element={<ChatPage />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </RoleProvider>
    </AuthProvider>
  );
}

export default App;